export default function generator(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    instructionsShowWrapperPadding: spacing.large,
    instructionsShowTextFontSize: typography.fontSizeMedium
  };
}